// SECURITY NOTE: JWT is stored in sessionStorage, which is readable by any JS
// running on this page. Any XSS vulnerability = full account takeover.
// Acceptable for closed beta. Before public launch: move to an HttpOnly cookie
// (requires CORS + SameSite=Strict) or a service-worker cache.
export function getAuthToken() {
  return sessionStorage.getItem("token");
}

export function setAuthToken(token) {
  sessionStorage.setItem("token", token);
}

export function logout() {
  sessionStorage.removeItem("token");
  localStorage.removeItem("token");
}
